import { QueryClient, useMutation } from "@tanstack/react-query";

/**
 * Allow params as an array
 * @param keyName
 * @param request
 * @param queryClient
 * @returns
 */
export const useMutationGQL = <TResult, TParams extends any[]>(
  keyName: string,
  request: (...args: TParams) => Promise<TResult>,
  queryClient?: QueryClient,
) => {
  const mutation = useMutation<TResult, Error, TParams>(
    {
      mutationKey: [keyName],
      mutationFn: async (params: TParams): Promise<TResult> => {
        return request(...params);
      },
    },
    queryClient,
  );

  return {
    mutationFn: mutation.mutateAsync,
    status: mutation.status,
  };
};

/**
 * Allow params an object (from nextjs variation)
 * @param keyName
 * @param request
 * @param queryClient
 * @returns
 */
export const useMutationGQL2 = <TResult, TParams>(
  keyName: string,
  request: (args: TParams) => Promise<TResult>,
  queryClient?: QueryClient,
) => {
  const mutation = useMutation<TResult, Error, TParams>(
    {
      mutationKey: [keyName],
      mutationFn: async (params: TParams): Promise<TResult> => {
        return request(params);
      },
    },
    queryClient,
  );

  return {
    mutationFn: mutation.mutateAsync,
    status: mutation.status,
  };
};
